<template>
    <div>
        <Modal v-model="modal" :title="!websiteHealthStatusWarningForm.id ? this.$t('alarms.websiteHealthStatus.addWebsiteHealthStatusAlarm'):this.$t('alarms.websiteHealthStatus.editWebsiteHealthStatusAlarm')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :closable="false">
            <Form ref="websiteHealthStatusWarningForm" :model="websiteHealthStatusWarningForm" :label-width="110" :rules="ruleValidate">
                <!-- 微信警告 -->
                <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
                <!-- 规则名称 -->
                <FormItem :label="$t('alarms.common.ruleName')" prop="ruleName" v-if="isEditRuleName">
                    <Row>
                        <Col span="11">
                            <Input type="text" v-model="websiteHealthStatusWarningForm.ruleName" :placeholder="$t('alarms.common.pleaseSelect')" style="width:300px;" :disabled="isEdit"></Input>
                        </Col>
                    </Row>
                </FormItem>

                <!-- 规则名称 -->
                <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
                    <Row >
                        <Col span="24">
                            <div>{{this.websiteHealthStatusWarningForm.ruleName}}</div>
                        </Col>
                    </Row>
                </FormItem>

                <!-- 账户 -->
                <FormItem :label="$t('alarms.common.account')" prop="account">
                    <Select v-model="websiteHealthStatusWarningForm.account" :transfer="true" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 网站地址 -->
                <FormItem :label="$t('alarms.websiteHealthStatus.host')">
                    <Row :gutter="4">
                        <!-- 网站地址 -->
                        <Col span="11">
                            <FormItem prop="host">
                                <Input v-model="websiteHealthStatusWarningForm.host" :placeholder="$t('alarms.websiteHealthStatus.host')" style="width:300px;"></Input>
                            </FormItem>
                        </Col>
                        <!-- 端口 -->
                        <Col span="4">
                            <FormItem prop="port">
                                <Input v-model="websiteHealthStatusWarningForm.port" :placeholder="$t('alarms.websiteHealthStatus.port')" type="number"></Input>
                            </FormItem>
                        </Col>
                        <!-- 连接超时时间 -->
                        <Col span="4">
                            <FormItem prop="timeout">
                                <Input v-model="websiteHealthStatusWarningForm.timeout" :placeholder="$t('alarms.websiteHealthStatus.timeout')" type="number"></Input>
                            </FormItem>
                        </Col>
                        <Col span="2">秒</Col>
                    </Row>
                </FormItem>

                <!-- 规则描述 -->
                <FormItem :label="$t('alarms.common.ruleDescription')">
                    <Row :gutter="4">
                        <!-- 监控指标 -->
                        <Col span="6">
                            <FormItem prop="monitorIndex">
                                <Select v-model="websiteHealthStatusWarningForm.monitorIndex" @on-change="changeMonitorIndex(websiteHealthStatusWarningForm.monitorIndex)" :placeholder="$t('alarms.common.pleaseSelect')">
                                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 周期 -->
                        <Col span="3">
                            <FormItem prop="cycle">
                                <Select v-model="websiteHealthStatusWarningForm.cycle" :placeholder="$t('alarms.common.cycle')" @on-change="changeCycle(websiteHealthStatusWarningForm.cycle)">
                                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 连续周期 -->
                        <Col span="4">
                            <FormItem prop="continousCycle">
                                <Select v-model="websiteHealthStatusWarningForm.continousCycle" :placeholder="$t('alarms.common.continuousCycle')" @on-change="changeContinousCycle(websiteHealthStatusWarningForm.continousCycle)">
                                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 统计数值 -->
                        <Col span="4">
                            <FormItem prop="statisticsValue">
                                <Select v-model="websiteHealthStatusWarningForm.statisticsValue" :placeholder="$t('alarms.common.continuousCycle')" @on-change="changeStatisticsValue(websiteHealthStatusWarningForm.statisticsValue)">
                                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index"> {{item.name}} </Option>
                                </Select>
                            </FormItem>
                        </Col>

                        <!-- 如果监控指标为Mailbox时 不显示符号、阈值和单位 -->
                        <div v-if="this.isShowField!=1">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="websiteHealthStatusWarningForm.relationshipSign" @on-change="changeRelationshipSign(websiteHealthStatusWarningForm.relationshipSign)" :placeholder="$t('alarms.common.symbol')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index"> {{item.name}} </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="websiteHealthStatusWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="websiteHealthStatusWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                        <div v-else-if="this.isShowField==2">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="websiteHealthStatusWarningForm.relationshipSign" @on-change="changeRelationshipSign(websiteHealthStatusWarningForm.relationshipSign)" :placeholder="$t('alarms.common.symbol')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index"> {{item.name}} </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="websiteHealthStatusWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')" type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="websiteHealthStatusWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                    </Row>
                </FormItem>

                <!-- 联系方式 -->
                <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
                    <RadioGroup v-model="websiteHealthStatusWarningForm.contactType" @on-change="changeContactType(websiteHealthStatusWarningForm.contactType)">
                        <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <!-- 通知对象 -->
                <FormItem :label="$t('alarms.common.notificationObject')" prop="notificationObject" v-if="websiteHealthStatusWarningForm.contactType==0">
                    <Select v-model="websiteHealthStatusWarningForm.notificationObject" multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 联系人组 -->
                <FormItem :label="$t('alarms.common.contactGroup')" prop="contactGroupIds" v-if="websiteHealthStatusWarningForm.contactType==1">
                    <Select v-model="websiteHealthStatusWarningForm.contactGroupIds" multiple style="width:300px;" @on-change="changeContactGroupId(websiteHealthStatusWarningForm.contactGroupIds)" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 报警方式 -->
                <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
                    <Select v-model="websiteHealthStatusWarningForm.noticeType" multiple style="width:300px;" @on-change="selectNoticeType(websiteHealthStatusWarningForm.noticeType)" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 企业微信机器人URL -->
                <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="websiteHealthStatusWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
                    <Select v-model="websiteHealthStatusWarningForm.enterpriseWechatRobotIds" multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 延迟告警 -->
                <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
                    <Select v-model="websiteHealthStatusWarningForm.alarmDelay" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 邮箱模板 -->
                <div v-show="isShowEmail">
                    <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
                        <Input v-model="websiteHealthStatusWarningForm.emailModal" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>

                <!-- 企业微信模板 -->
                <div v-show="isShowWeChat">
                    <FormItem :label="$t('alarms.common.wechatModal')" prop="wechatModal">
                        <Input v-model="websiteHealthStatusWarningForm.wechatModal" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>
            </Form>
            <div slot="footer">
                <Button size="large" @click="cancel('websiteHealthStatusWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
                <Button type="primary" size="large" @click="ok('websiteHealthStatusWarningForm')" :loading="addloading" :disabled="isAddOrEdit"> {{!websiteHealthStatusWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import WechatWarning from '../../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'

    var tableWebsiteHealthStatusWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.websiteHealthStatusWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error('规则名称不能重复!'));
                    }
                })
            };

            return {
                addloading:false,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                {
                    label: this.$t('alarms.common.contactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                isShowField: '', //是否显示符号、阈值和单位
                alarmDelayList: [],
                isEdit: false,
                isEditRuleName: false,
                showRuleName: false,
                isShowEmail: false,
                isShowWeChat: false,
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                unit: '',
                monitorModule: 36,
                websiteHealthStatusWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    alarmDelay: '',
                    contactType: 0,
                    contactGroupIds: [],
                    userIdList:[],
                    host:'',
                    port:'',
                    timeout:5,
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList: [],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: '请选择账户名称', trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: '请选择延迟告警', trigger: 'change', type: 'number'}
                    ],
                    ruleName: [
                        {required: true, message: '规则名称不能为空', trigger: 'blur'},
                        {type: 'string', message: '规则名称为2-20个字符首尾中间不能有空格', pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: '请选择通知对象', trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: '请选择报警方式', trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: '请选择监控指标', trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: '请选择周期', trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: '请选择连续周期', trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: '请选择统计数值', trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: '请选择关系符号', trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: '请输入阈值'}
                    ],
                    host: [
                        {required: true, message: '请输入网站地址'}
                    ],
                    port: [
                        {required: true, message: '请输入端口'}
                    ],
                    timeout: [
                        {required: true, message: '连接超时时间'}
                    ],
                    contactType: [
                        {required: true, message: '请选择联系方式', trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: '请选择联系人组', trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                        {required: true, type: 'array', message: '请选择企业微信机器人URL', trigger: 'change'}
                    ]
                }
            }
        },
        beforeCreate: function () {
            tableWebsiteHealthStatusWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            init: function (id) {
                this.websiteHealthStatusWarningForm.id = id || 0;
                tableWebsiteHealthStatusWarningVue.searchAll();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['websiteHealthStatusWarningForm'].resetFields();
                    // 编辑
                    if (this.websiteHealthStatusWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.$api.alertRule.selectAlertRule("id", this.websiteHealthStatusWarningForm.id)
                        .then(res => {
                            //账号
                            this.websiteHealthStatusWarningForm.account = res.data.accountId;
                            //延时
                            this.websiteHealthStatusWarningForm.alarmDelay = res.data.delay;
                            // 规则名称
                            this.websiteHealthStatusWarningForm.ruleName = res.data.alertRuleName;
                            // 网站地址
                            this.websiteHealthStatusWarningForm.host = res.data.websiteInfoDTO.host;
                            // 端口
                            this.websiteHealthStatusWarningForm.port = res.data.websiteInfoDTO.port;
                            // 连接超时时间
                            this.websiteHealthStatusWarningForm.timeout = res.data.websiteInfoDTO.timeout;

                            // 监控指标
                            /******************************************************/
                            // 查询监控指标
                            tableWebsiteHealthStatusWarningVue.$api.alertRule.searchDefaultMonitorIndex(
                                "monitorModule", this.monitorModule
                            )
                            .then(res => {
                                this.monitorIndexList = res.data;
                            })
                            this.websiteHealthStatusWarningForm.monitorIndex = res.data.monitorIndex;
                            // 如果监控指标为Mailbox时 不显示符号、阈值和单位
                            if (this.websiteHealthStatusWarningForm.monitorIndex == 1201) {
                                this.isShowField = 1;
                            } else {
                                this.isShowField = 2;
                            }

                            // 周期
                            this.websiteHealthStatusWarningForm.cycle = res.data.cycle;
                            // 连续周期
                            this.websiteHealthStatusWarningForm.continousCycle = res.data.continousCycle;
                            // 统计数值
                            this.websiteHealthStatusWarningForm.statisticsValue = res.data.statisticsValue;
                            // 符号
                            this.websiteHealthStatusWarningForm.relationshipSign = res.data.relationshipSign;
                            // 阈值
                            this.websiteHealthStatusWarningForm.thresholdValue = res.data.thresholdStringValue;
                            // 单位
                            this.websiteHealthStatusWarningForm.unit = res.data.unit;
                            this.units = res.data.unitId;
                            // 联系方式
                            this.websiteHealthStatusWarningForm.contactType = res.data.contactType;
                            // 企业微信机器人URL
                            this.websiteHealthStatusWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;
                            if (res.data.contactType == 0) {
                                // 通知对象
                                this.websiteHealthStatusWarningForm.notificationObject = res.data.contactIDs;
                                for(var i=0;i<this.websiteHealthStatusWarningForm.notificationObject.length;i++){
                                    for(var j=0;j<this.notificationObjectList.length;j++){
                                        if(this.websiteHealthStatusWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                            this.websiteHealthStatusWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                        }
                                    }
                                }
                            } else if (res.data.contactType == 1) {
                                // 联系人组
                                this.$api.contactGroup.listContactGroups()
                                .then(res => {
                                    this.contactGroupIdList = res.data;
                                })
                                setTimeout(() => {
                                    this.websiteHealthStatusWarningForm.contactGroupIds = res.data.contactGroupIds;
                                }, 1000)
                            }

                            // 查询阈值
                            tableWebsiteHealthStatusWarningVue.selectMonitorIndexDefault();

                            // 报警方式
                            this.websiteHealthStatusWarningForm.noticeType = res.data.noticeType;

                            for (var i = 0; i < this.websiteHealthStatusWarningForm.noticeType.length; i++) {
                                if (this.websiteHealthStatusWarningForm.noticeType[i] == '0') {
                                    this.isShowEmail = true;
                                    this.websiteHealthStatusWarningForm.emailModal = res.data.briefReportBodyMail;
                                    this.noticeType = this.websiteHealthStatusWarningForm.noticeType;
                                    tableWebsiteHealthStatusWarningVue.selectTemplate();
                                }
                                if (this.websiteHealthStatusWarningForm.noticeType[i] == '1') {
                                    // this.isShowWeChat = true;
                                    this.websiteHealthStatusWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                    this.checkLeastOnePersonBoundWeChat();
                                    this.noticeType = this.websiteHealthStatusWarningForm.noticeType;
                                    tableWebsiteHealthStatusWarningVue.selectTemplate();
                                }else if(this.websiteHealthStatusWarningForm.noticeType[i]!='1'){
                                    this.wechatWarningVisible=false;
                                    this.isAddOrEdit=false;
                                }
                            }
                        })
                    } else {
                        this.isEdit = false;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.websiteHealthStatusWarningForm.cycle = '';
                this.websiteHealthStatusWarningForm.continousCycle = '';
                this.websiteHealthStatusWarningForm.statisticsValue = '';
                this.websiteHealthStatusWarningForm.relationshipSign = '';
                this.websiteHealthStatusWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                // 如果监控指标为Mailbox时 不显示符号、阈值和单位
                if (this.websiteHealthStatusWarningForm.monitorIndex == 1201) {
                    this.isShowField = 1;
                } else {
                    this.isShowField = 2;
                }
                tableWebsiteHealthStatusWarningVue.selectMonitorIndexDefault();
                this.unit = this.websiteHealthStatusWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.websiteHealthStatusWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableWebsiteHealthStatusWarningVue.selectTemplate();
                tableWebsiteHealthStatusWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                tableWebsiteHealthStatusWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.websiteHealthStatusWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.websiteHealthStatusWarningForm.cycle,
                    "continousCycle": this.websiteHealthStatusWarningForm.continousCycle,
                    "statisticsValue": this.websiteHealthStatusWarningForm.statisticsValue,
                    "relationshipSign": this.websiteHealthStatusWarningForm.relationshipSign
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableWebsiteHealthStatusWarningVue.isNotEmpty(this.websiteHealthStatusWarningForm.cycle) && tableWebsiteHealthStatusWarningVue.isNotEmpty(this.websiteHealthStatusWarningForm.continousCycle) && tableWebsiteHealthStatusWarningVue.isNotEmpty(this.websiteHealthStatusWarningForm.statisticsValue) && tableWebsiteHealthStatusWarningVue.isNotEmpty(this.websiteHealthStatusWarningForm.relationshipSign) && this.websiteHealthStatusWarningForm.id == 0) {
                          this.websiteHealthStatusWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }
                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableWebsiteHealthStatusWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.websiteHealthStatusWarningForm.monitorIndex,
                    "relationshipSign": this.websiteHealthStatusWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.websiteHealthStatusWarningForm.noticeType
                })
                .then(res => {
                    this.websiteHealthStatusWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.websiteHealthStatusWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectNoticeType: function () {
                this.isShowEmail = false;
                this.isShowWeChat = false;
                for (var i = 0; i < this.websiteHealthStatusWarningForm.noticeType.length; i++) {
                    if (this.websiteHealthStatusWarningForm.noticeType[i] == '0') {
                        this.isShowEmail = true;
                        this.noticeType = this.websiteHealthStatusWarningForm.noticeType;
                        tableWebsiteHealthStatusWarningVue.selectTemplate();
                    }
                    if (this.websiteHealthStatusWarningForm.noticeType[i] == '1') {
                        // this.isShowWeChat = true;
                        this.noticeType = this.websiteHealthStatusWarningForm.noticeType;
                        this.checkLeastOnePersonBoundWeChat();
                        tableWebsiteHealthStatusWarningVue.selectTemplate();
                    }else if(this.websiteHealthStatusWarningForm.noticeType[i]!='1'){
                        this.wechatWarningVisible=false;
                        this.isAddOrEdit=false;
                    }
                }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
                for(var i=0;i<this.websiteHealthStatusWarningForm.noticeType.length;i++){
                    if(this.websiteHealthStatusWarningForm.noticeType[i]==1){
                        var weChatDate={
                            "contactType":this.websiteHealthStatusWarningForm.contactType
                        };
                        // 联系方式为 -联系人-
                        if(this.websiteHealthStatusWarningForm.contactType==0){
                            weChatDate.userIds=this.websiteHealthStatusWarningForm.userIdList;
                        }
                        // 联系方式为 -联系人组-
                        else if(this.websiteHealthStatusWarningForm.contactType==1){
                            weChatDate.contactGroupIds = this.websiteHealthStatusWarningForm.contactGroupIds;
                        }
                        this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                        .then(res => {
                            if(res.data){
                                // 可以添加告警
                                this.wechatWarningVisible=false;
                                this.isAddOrEdit=false;
                            }else{
                                // 不可以添加微信告警
                                this.wechatWarningVisible=true;
                                this.isAddOrEdit=true;
                            }
                        })
                    }else if(this.websiteHealthStatusWarningForm.noticeType[i]!=1){
                        this.wechatWarningVisible=false;
                        this.isAddOrEdit=false;
                    }
                }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroups()
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
                this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
                this.websiteHealthStatusWarningForm.userIdList=[];
                this.websiteHealthStatusWarningForm.notificationObject=val;
                for(var i=0;i<this.websiteHealthStatusWarningForm.notificationObject.length;i++){
                    for(var j=0;j<this.notificationObjectList.length;j++){
                        if(this.websiteHealthStatusWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                            this.websiteHealthStatusWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                        }
                    }
                }
                this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
                this.checkLeastOnePersonBoundWeChat();
            },
            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function () {
                tableWebsiteHealthStatusWarningVue.$api.alertRule.searchDefaultMonitorIndex(
                    "monitorModule", this.monitorModule
                )
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableWebsiteHealthStatusWarningVue.$api.contact.queryContacts("monitorModule", this.monitorModule)
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.websiteHealthStatusWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableWebsiteHealthStatusWarningVue.$api.alertRule.alarmWay("userName", getCookie(global.cookieName))
                .then(res => {
                    this.alarmWayList = res.data;
                })
            },
            // 查询报警延迟
            getAlarmDelay: function () {
                tableWebsiteHealthStatusWarningVue.$api.alertRule.alarmDelay("userName", getCookie(global.cookieName))
                .then(res => {
                    this.alarmDelayList = res.data;
                })
            },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableWebsiteHealthStatusWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableWebsiteHealthStatusWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableWebsiteHealthStatusWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableWebsiteHealthStatusWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableWebsiteHealthStatusWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            searchAll: function () {
                // 查询联系人组
                tableWebsiteHealthStatusWarningVue.listContactGroups();
                // 查询账号
                tableWebsiteHealthStatusWarningVue.getAccount();
                // 查询规则描述
                tableWebsiteHealthStatusWarningVue.searchMonitorIndex();
                // 查询通知对象
                tableWebsiteHealthStatusWarningVue.queryContacts();
                // 查询方式
                tableWebsiteHealthStatusWarningVue.alarmWay();
                // 查询报警延时
                tableWebsiteHealthStatusWarningVue.getAlarmDelay();
                // 监控模块查询关联的机器人列表
                tableWebsiteHealthStatusWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableWebsiteHealthStatusWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                    "monitorModule":this.monitorModule
                })
                .then(res => {
                    this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            getAccount: function () {
                // 清空表格
                this.$api.account.queryAWSAccounts("userName", getCookie(global.cookieName))
                .then(res => {
                    this.accountList = res.data;
                    for (var i = 0; i < this.accountList.length; i++) {
                        this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                    }
                })
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        if(this.websiteHealthStatusWarningForm.host&&this.websiteHealthStatusWarningForm.port&&this.websiteHealthStatusWarningForm.timeout){
                            // 检验网站是否可以TCP连接
                            this.$api.websiteInfo.verifyWebsiteInfoConnected({
                                "host": this.websiteHealthStatusWarningForm.host,
                                "port": this.websiteHealthStatusWarningForm.port,
                                "timeout": this.websiteHealthStatusWarningForm.timeout
                            })
                            .then(res => {
                                if (res.status == 200) {
                                    var alertList = {
                                        "accountId": this.websiteHealthStatusWarningForm.account,
                                        "alertRuleName": this.websiteHealthStatusWarningForm.ruleName,
                                        "monitorIndex": this.websiteHealthStatusWarningForm.monitorIndex,
                                        "cycle": this.websiteHealthStatusWarningForm.cycle,
                                        "continousCycle": this.websiteHealthStatusWarningForm.continousCycle,
                                        "statisticsValue": this.websiteHealthStatusWarningForm.statisticsValue,
                                        "relationshipSign": this.websiteHealthStatusWarningForm.relationshipSign,
                                        "monitorModule": this.monitorModule,
                                        "noticeType": this.websiteHealthStatusWarningForm.noticeType,
                                        "unit": this.units,
                                        "delay": this.websiteHealthStatusWarningForm.alarmDelay,
                                        "thresholdStringValue": this.websiteHealthStatusWarningForm.thresholdValue,
                                        "contactType": this.websiteHealthStatusWarningForm.contactType,
                                        "websiteInfoDTO":{
                                            "host" : this.websiteHealthStatusWarningForm.host,
                                            "port" : this.websiteHealthStatusWarningForm.port,
                                            "timeout" : this.websiteHealthStatusWarningForm.timeout
                                        },
                                        "enterpriseWechatRobotIds":this.websiteHealthStatusWarningForm.enterpriseWechatRobotIds
                                    };

                                    // 如果联系方式是联系人 传通知对象
                                    if (this.websiteHealthStatusWarningForm.contactType == 0) {
                                        alertList.contactIDs = this.websiteHealthStatusWarningForm.notificationObject;
                                    }
                                    // 如果联系方式是联系人组 传联系人组
                                    else if (this.websiteHealthStatusWarningForm.contactType == 1) {
                                        alertList.contactGroupIds = this.websiteHealthStatusWarningForm.contactGroupIds;
                                    }

                                    if (this.websiteHealthStatusWarningForm.id > 0) {
                                        alertList.id = this.websiteHealthStatusWarningForm.id;
                                        // 编辑告警
                                        this.addloading=true;
                                        tableWebsiteHealthStatusWarningVue.$api.alertRule.updateAlertRule(alertList)
                                        .then(res => {
                                            setTimeout(() => {
                                                this.reload();
                                                this.websiteHealthStatusWarningForm.notificationObject = [];
                                                this.$refs[name].resetFields();
                                                this.loading = false;
                                                this.$nextTick(() => {
                                                    this.loading = true;
                                                });
                                                this.$Message.success('编辑成功');
                                                this.isShowEmail = false;
                                                this.isShowWeChat = false;
                                                this.addloading=false;
                                                this.modal = false;
                                                this.wechatWarningVisible=false;
                                                this.isAddOrEdit=true;
                                            }, 1000);
                                        })
                                    } else {
                                        // 添加告警
                                        this.addloading=true;
                                        tableWebsiteHealthStatusWarningVue.$api.alertRule.createAlertRule(alertList)
                                        .then(res => {
                                            setTimeout(() => {
                                                this.reload();
                                                this.websiteHealthStatusWarningForm.notificationObject = [];
                                                this.$refs[name].resetFields();
                                                this.loading = false;
                                                this.$nextTick(() => {
                                                    this.loading = true;
                                                });
                                                this.$Message.success('添加成功');
                                                this.monitorIndexList = [];
                                                this.isShowEmail = false;
                                                this.isShowWeChat = false;
                                                this.addloading=false;
                                                this.modal = false;
                                                this.wechatWarningVisible=false;
                                                this.isAddOrEdit=true;
                                            }, 1000);
                                        })
                                    }
                                }
                            })
                            .catch(err => {
                                if (err.status == 400) {
                                    this.$Message.error('该网址TCP无法连接!');
                                    this.loading = false;
                                    this.$nextTick(() => {
                                      this.loading = true;
                                    });
                                }
                            })
                        }
                    } else {
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.websiteHealthStatusWarningForm.id > 0) {
                            this.$Message.error('编辑失败');
                        } else {
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.websiteHealthStatusWarningForm.notificationObject = [];
                this.monitorIndexList = [];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                this.modal = false;
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/non_cloud_resources/website_health_status/AddOrUpdateWebsiteHealthStatusWarning.vue